import createReducer from '../createReducer';

const initialState = {
    videos: [],
    videoRatings: [],
    videoComments: [],
};

const reducer = createReducer('management', initialState);

export default reducer;
